// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error_errorPage__158HA","icon":"error_icon__12706","message":"error_message__1oKtY","btn":"error_btn__oag1p"};